import { useEffect } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

import cookies from '../cookies';
import { getStoredPendingPushTarget, initializePushNotifications } from './pushNotifications';
import { isNativeAndroidApp } from './platform';
import { getChatsPathForPushTarget, PUSH_PENDING_TARGET_EVENT } from './pushNotificationTarget';

export const PushNotificationsController = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeAndroidApp()) {
      return;
    }

    void initializePushNotifications();
  }, [location.pathname, location.search]);

  useEffect(() => {
    if (!isNativeAndroidApp()) {
      return;
    }

    let effectStale = false;
    const tryNavigateToPendingTarget = async () => {
      const pendingTarget = await getStoredPendingPushTarget();
      const token = (cookies.get('token') as string | undefined) || '';

      if (effectStale || !pendingTarget || !token) {
        return;
      }

      if (location.pathname === '/') {
        return;
      }

      const nextPath = getChatsPathForPushTarget();
      void navigate(nextPath, { replace: true });
    };

    void tryNavigateToPendingTarget();

    const onPendingTargetChanged = () => {
      void tryNavigateToPendingTarget();
    };

    window.addEventListener(PUSH_PENDING_TARGET_EVENT, onPendingTargetChanged);

    return () => {
      effectStale = true;
      window.removeEventListener(PUSH_PENDING_TARGET_EVENT, onPendingTargetChanged);
    };
  }, [location.pathname, navigate]);

  return null;
};
